var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"hide-details":"","items":_vm.targetingGeoLocationsTypes,"item-text":"name","item-value":"key","outlined":"","value":_vm.value},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }